import { placeOrder } from "../common/features/cart/cartActions";
import { Cart, CartTotal } from "../common/features/cart/cartModels";
import { EmptyLocationDetails } from "../common/features/cart/cartReducer";
import {
  getEditCartItemFromCartItem,
  getTotalByCode,
  mergeTotals,
} from "../common/utils/cart-utils";
import {
  getDateString,
  getTimeString,
} from "../common/utils/date-time-helper-utils";
import {
  getDecimalPlacedPrice,
  getTwoDecimalValue,
} from "../common/utils/menu-helper-utils";
import { addMinutes } from "date-fns";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CHECKIN_TABLE_ID } from "../common/constants";
import { useParams } from "react-router";

import {
  EditOrderItem,
  EditOrderRequestCart,
} from "../common/features/order/orderModels";
import { updateOrderDetail } from "../common/features/order/orderActions";
import { DeliveryProviders } from "../common/features/delivery/DeliveryModels";
import { Tax } from "../common/features/restaurant/restaurantModels";
import moment from "moment-timezone";

const UpdateOrderTypes = ["OrderUpdate", "TotalUpdate"] as const;

export type UpdateOrderType = (typeof UpdateOrderTypes)[number];

export const useOnlinePlaceOrder = (isContactlessDineInOrder?:boolean): [
  () => void,
  (type: UpdateOrderType, updatedTipTotals?: CartTotal) => void,
  number|string,//order total
  number|string,//item total
  Array<any>,//order totals
  number|string,//tip value
  number|string,//discount
  number|string,//delivery fee
] => {
  const dispatch = useDispatch();  
  let paramsData = useParams<any>();
  const restaurantOrderTypeId1 = useSelector((state: any) => state.restaurant.restaurantOrderTypeId);

  const restaurantDefaulPickuptEta = useSelector(
    (state: any) => state.cart.cartRestaurantDetails?.defaultPickUpETA
  );

  const restaurantDefaulDeliverytEta = useSelector(
    (state: any) => state.cart.cartRestaurantDetails?.defaultDeliveryETA
  );

  const selectedOffer = useSelector(
    (state: any) => state.offer.selectedOffer
  );

  const cartRestaurantDetails = useSelector(
    (state: any) => state.restaurant.currentRestaurantDetail
  );

  let dineInOrderTypeDetails = cartRestaurantDetails.orderTypes?.filter(
    (e: any) => e.id === restaurantOrderTypeId1
  )[0];

  const orderDetail = useSelector(
    (state: any) => state.order.currentOrderDetail
  );

  const cart = useSelector((state: any) => state.cart.cart);

  const runningCartDetails = useSelector(
    (state: any) => state.cart.runningCart
  );

  const placeOrderLoading = useSelector(
    (state: any) => state.cart.placeOrderLoading
  );

  const restaurantDetails = useSelector(
    (state: any) => state.cart.cartRestaurantDetails
  );

  const currentOrderDetail = useSelector((state: any) => state.order.currentOrderDetail);

  const isSchedularOrder = useSelector((state: any) => state.cart?.isScheduleOrder);

  const orderTotal =  useSelector((state: any) => state.order.orderTotal);
  const orderApiTotals = useSelector((state: any) => state.order.totals);
  const orderItems = useSelector((state: any) => state.order.orderItems);
  const orderItemSubTotals = useMemo(() => { return getTwoDecimalValue(getTotalByCode(orderApiTotals, "1")?.value || 0)},[orderApiTotals])

  const tipValue = useSelector((state: any) => state.cart.tipValue);
  const tipType = useSelector((state: any) => state.cart.tipType);

  let tipAmount =
  tipType == "FLATFEE"
    ? Number(tipValue)
    : tipValue > 0
    ? getTwoDecimalValue(
      ((getTwoDecimalValue(tipValue) / 100) * orderItemSubTotals))
    : 0;

  const discountAmount = useMemo(() => {
    let amount = 0;
    if (
      selectedOffer &&
      orderItemSubTotals >= selectedOffer?.minOrderAmount &&
      selectedOffer.offerType === "PERCENT"
    ) {
      let discount = (selectedOffer.offerRate / 100) * orderItemSubTotals;
      amount =
        discount > selectedOffer.maxDiscount
          ? selectedOffer.maxDiscount
          : discount;
    } else if (
      selectedOffer &&
      orderItemSubTotals >= selectedOffer?.minOrderAmount
    ) {
      amount = selectedOffer?.maxDiscount;
    }
    return amount;
  }, [selectedOffer, orderItemSubTotals]);

  const restaurantOrderTypeId = useSelector((state: any) => state.restaurant.restaurantOrderTypeId);


    const isDeliveryOrder = useMemo(() => {
    let filteredOrderTypes = restaurantDetails
      ? restaurantDetails.orderTypes?.filter(
          (orderType: any) => orderType.id == restaurantOrderTypeId
        )
      : [];
    return filteredOrderTypes && filteredOrderTypes.length > 0
      ? filteredOrderTypes[0].typeGroup == "S"
      : false;
  }, [restaurantDetails, restaurantOrderTypeId]);


  const getWindowedDateString = () => {
    const restaurantDefaultEta = isDeliveryOrder ? restaurantDefaulDeliverytEta : restaurantDefaulPickuptEta;
    return getDateString(
      addMinutes(new Date(), restaurantDefaultEta || 0).toISOString()
    );
  };

  const getWindowedTimeString = () => {
    const restaurantDefaultEta = isDeliveryOrder ? restaurantDefaulDeliverytEta : restaurantDefaulPickuptEta;
        if (isEventDate) {
          return getTimeString(addMinutes(selectedDate, 0).toISOString());
        }
        if (selectedDate) {
          return getTimeString(addMinutes(selectedDate, 0).toISOString());
        } else {
          return getTimeString(addMinutes(new Date(), restaurantDefaultEta || 0).toISOString());
        }
  };

  const getAmountInDecimal = (amount: any) => {
    return parseFloat(amount).toFixed(3).slice(0, -1);
  };


  //make order
  const restaurantId = useSelector((state: any) => state.restaurant.currentRestaurantDetail.id);
  const UserAuthId = useSelector((state: any) => state.auth.user?.id);
  const guestUser = useSelector((state: any) => state.auth.guestUser);
const orderNote = useSelector((state: any) => state.cart.orderInstruction);
 const deliveryNote = useSelector((state: any) => state.cart.deliveryInstruction);

  const guestCount = useSelector((state: any) => state.restaurant.cdGuestCount);

  const isEventDate = useSelector((state: any) => state.cart.isEventDate);
  const eventSlug = useSelector((state: any) => state.cart.eventDate);
  const eventSlot = useSelector((state: any) => state.cart.selectedTimeSlot);
 const selectedDate = useSelector((state: any) => state.cart?.selectedDate);


  const isASAP = useSelector((state: any) => state.cart.orderTimeASAP);
  const pickUpDate =  !cart.pickUpDate || cart.pickUpDate.length == 0 || isASAP? getWindowedDateString(): cart.pickUpDate;
  const deliveryDate = !cart.deliveryDate || cart.deliveryDate.length == 0 || isASAP ? getWindowedDateString(): cart.deliveryDate;

  const deliveryAddress = useSelector((state: any) => state.cart.deliveryAddress);
  const locationDetails = deliveryAddress ? deliveryAddress: EmptyLocationDetails;

  const checkInTableId = localStorage.getItem(CHECKIN_TABLE_ID);
  const tableId = paramsData.tableId ? paramsData.tableId : checkInTableId ? checkInTableId: null;

  const isContactlessDineinV2 = useMemo(() => {
    return restaurantDetails && restaurantDetails.dining == 3;
  }, [restaurantDetails]);

  const isDineInOrder = useMemo(() => {
    return (
      dineInOrderTypeDetails &&
      dineInOrderTypeDetails.typeGroup === "D" &&
      tableId
    );
  }, [dineInOrderTypeDetails, tableId]);


  //calculate delivery fee start

  const deliveryDistance = useSelector(
    (state: any) => state.cart.cart.deliveryDistance
  );

  const deliveryQuotationDetails = useSelector(
    (state: any) => state.delivery.deliveryQuotationDetails
  );

  const initialDeliveryKm = useSelector(
    (state: any) =>
      state.restaurant.currentRestaurantDetail.deliverySettings?.initialKm
  );

  const initialDeliveryCharge = useSelector(
    (state: any) =>
      state.restaurant.currentRestaurantDetail.deliverySettings?.initialCost
  );

  const maximumDeliveryFee = useSelector(
    (state: any) =>
      state.restaurant.currentRestaurantDetail.deliverySettings?.maxDeliveryFee
  );

  const deliveryAdditionalCharge = useSelector(
    (state: any) =>
      state.restaurant.currentRestaurantDetail.deliverySettings?.additionalCost
  );

  const restaurantOrderTax = useSelector(
    (state: any) => state.cart.cartRestaurantOrderTax
  );

  const platformConfiguration = useSelector(
    (state: any) =>
      state.cart.cartRestaurantDetails?.platformConfiguration
  );


  const getAdditionalDeliveryCharge = () => {
    if (
      initialDeliveryCharge &&
      initialDeliveryKm &&
      deliveryAdditionalCharge
    ) {
      return (
        initialDeliveryCharge +
        Math.ceil(deliveryDistance - initialDeliveryKm) *
          deliveryAdditionalCharge
      );
    }
  };


  const getCalculatedValue = (amount: number, value: any) => {
    if (value.type == "FLATFEE") {
      return value.rate;
    } else if (value.type == "PERCENT") {
      return amount * (value.rate / 100);
    } else {
      return 0;
    }
  };


  const deliveryCharges = useMemo(() => {
    if (
      deliveryDistance &&
      restaurantDetails &&
      restaurantDetails.deliverySettings &&
      initialDeliveryKm &&
      initialDeliveryCharge &&
      maximumDeliveryFee
    ) {
      if (deliveryDistance < initialDeliveryKm) {
        return initialDeliveryCharge;
      } else if (deliveryDistance >= initialDeliveryKm) {
        let additionalDeliveryCharge = getAdditionalDeliveryCharge();
        if (
          additionalDeliveryCharge &&
          additionalDeliveryCharge > maximumDeliveryFee
        ) {
          return maximumDeliveryFee;
        } else {
          return additionalDeliveryCharge;
        }
      }
    } else {
      return 0;
    }
  }, [deliveryDistance, restaurantDetails]);

  const deliverySetting = useMemo(() => {
    return restaurantDetails?.deliverySettings;
  }, [restaurantDetails]);

  const deliveryDiscountSettings = useMemo(() => {
    return deliverySetting?.deliveryDiscountSettings;
  }, [deliverySetting]);

  const packagingCharges = useMemo(() => {
    const packagingCharge = restaurantOrderTax.filter(
      (u: Tax) => u.name === "PACKAGING_CHARGE"
    );
    if (packagingCharge.length > 0) {
      return getCalculatedValue(orderItemSubTotals, packagingCharge[0]);
    } else return 0;
  }, [restaurantOrderTax, orderItemSubTotals]);

  const packagingCharge = useMemo(() => {
    const restaurantOrderTaxEnabled = restaurantOrderTax.length > 0;
    if (isDeliveryOrder && platformConfiguration && restaurantDetails) {
      // Delivery Orders
      const thirdPartyDeliveryPartners = [
        DeliveryProviders.DUNZO,
        DeliveryProviders.SHADOWFAX,
        DeliveryProviders.SIMPERY,
        DeliveryProviders.DOORDASH,
      ];
      const magilFlatFeeForDelivery =
        platformConfiguration &&
        platformConfiguration.magilDeliveryFee &&
        restaurantDetails.country == "US"
          ? platformConfiguration.magilDeliveryFee &&
            platformConfiguration.magilDeliveryFee.us
          : platformConfiguration.magilDeliveryFee &&
            platformConfiguration.magilDeliveryFee.ind;
      if (
        restaurantDetails &&
        restaurantDetails.locationDeliveryProviders &&
        restaurantDetails.locationDeliveryProviders?.deliveryProviderId &&
        thirdPartyDeliveryPartners.includes(
          restaurantDetails.locationDeliveryProviders.deliveryProviderId
        ) &&
        deliveryQuotationDetails
      ) {
        // Thirdparty delivery
        return deliveryQuotationDetails.estimatedPrice
          ? parseFloat(deliveryQuotationDetails.estimatedPrice) +
              magilFlatFeeForDelivery.thirdPartyDelivery
          : magilFlatFeeForDelivery.thirdPartyDelivery;
      } else if (deliverySetting?.isInHouseDelivery) {
        // Inhouse delivery
        if (deliverySetting.chargePerKm > 0) {
          // computing delivery fee without Magil's flatfee
          const computedChargePerKmFee = restaurantOrderTaxEnabled
            ? deliveryDistance *
              (getCalculatedValue(orderItemSubTotals, restaurantOrderTax[0]) /
                deliverySetting.chargePerKm)
            : 0;
          // Amount per distance fee ,  Inhouse delivery
          if (deliverySetting.maxDeliveryFee > 0) {
            return deliverySetting.maxDeliveryFee > computedChargePerKmFee
              ? computedChargePerKmFee + magilFlatFeeForDelivery.inhouseDelivery
              : deliverySetting.maxDeliveryFee;
          } else {
            // max Delivery fee is not configured
            return (
              computedChargePerKmFee + magilFlatFeeForDelivery.inhouseDelivery
            );
          }
        } else {
          // Flatfee ,  Inhouse delivery
          return deliveryCharges
            ? deliveryCharges + magilFlatFeeForDelivery.inhouseDelivery
            : magilFlatFeeForDelivery.inhouseDelivery;
        }
      } else {
        // if not third party and inhousedelivery
        // return restaurantOrderTaxEnabled
        //   ? getCalculatedValue(totalItemsubTotal, restaurantOrderTax[0])
        //   : 0;
        return deliveryCharges
          ? deliveryCharges + magilFlatFeeForDelivery.inhouseDelivery
          : magilFlatFeeForDelivery.inhouseDelivery;
      }
    }

    else {
      return deliveryCharges ? deliveryCharges : packagingCharges;
    }
  }, [
    restaurantOrderTax,
    orderItemSubTotals,
    deliveryQuotationDetails,
    restaurantDetails,
    deliveryDistance,
    isDeliveryOrder,
  ]);

  const DeliveryFee = useMemo(() => { 
    return isDeliveryOrder ? packagingCharge : '0.00';
  },[packagingCharge,isDeliveryOrder])

  function to24HourFormat(time: any) {
    if (!time) return "";

    const [t, modifier] = time.trim().split(" ");
    let [hours, minutes] = t.split(":").map(Number);

    if (modifier?.toLowerCase() === "pm" && hours !== 12) hours += 12;
    if (modifier?.toLowerCase() === "am" && hours === 12) hours = 0;

    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:00`;
  }
const toItemQuantityNumber = (value: any) => {
    const parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed <= 0) {
      return 1;
    }
    return Math.floor(parsed);
  };

const normalizeItemOptionsForOrder = (item: any) => {
    const lineItemQty = toItemQuantityNumber(item?.quantity);
    const optionTemplates = Array.isArray(item?.options) ? item.options : [];
    const selectedModifierIds = String(item?.modifierIds || "")
      .split(",")
      .map((id) => id.trim())
      .filter((id) => id && id !== "0");

    const selectedModifierCounts = selectedModifierIds.reduce(
      (counts: Record<string, number>, id: string) => {
        counts[id] = (counts[id] || 0) + 1;
        return counts;
      },
      {}
    );

    const groupedTemplateOptions = optionTemplates.reduce((allOptions: any[], option: any) => {
      const optionId = option?.modifierOptionId ? String(option.modifierOptionId) : "";
      const existingIndex = allOptions.findIndex(
        (itemOption: any) =>
          (itemOption?.modifierOptionId && optionId && itemOption.modifierOptionId === optionId) ||
          (!optionId &&
            itemOption?.optionName === option?.optionName &&
            Number(itemOption?.price || 0) === Number(option?.price || 0))
      );
      const qty = Number.isFinite(Number(option?.quantity))
        ? Math.max(0, Math.floor(Number(option.quantity)))
        : 1;
      if (qty <= 0) {
        return allOptions;
      }
      const normalizedPrice = Number.isFinite(Number(option?.price)) ? Number(option.price) : 0;
      if (existingIndex >= 0) {
        allOptions[existingIndex] = {
          ...allOptions[existingIndex],
          quantity: (Number(allOptions[existingIndex]?.quantity) || 1) + qty,
          price: normalizedPrice,
        };
        return allOptions;
      }
      allOptions.push({
        ...option,
        price: normalizedPrice,
        quantity: qty,
      });
      return allOptions;
    }, []);

    if (Object.keys(selectedModifierCounts).length > 0) {
      const templateByModifierId = optionTemplates.reduce(
        (acc: Record<string, any>, option: any) => {
          if (option?.modifierOptionId && !acc[option.modifierOptionId]) {
            acc[option.modifierOptionId] = option;
          }
          return acc;
        },
        {}
      );

      const normalizedOptions: any[] = [];
      for (const [modifierOptionId, count] of Object.entries(selectedModifierCounts)) {
        const template = templateByModifierId[modifierOptionId];
        if (!template) {
          return groupedTemplateOptions;
        }
        const normalizedPrice = Number.isFinite(Number(template?.price)) ? Number(template.price) : 0;
        normalizedOptions.push({
          ...template,
          modifierOptionId,
          price: normalizedPrice,
          quantity: Math.max(1, Number(count) || 1) * lineItemQty,
        });
      }
      return normalizedOptions;
    }

    return groupedTemplateOptions;
  };
  const normalizedOrderItems = (orderItems || []).map((item: any) => ({
 
    ...item,
    options: normalizeItemOptionsForOrder(item),
 
  }));
 
//delivery fee calculate end
  const makeOrder = () => {
    const cdUser = JSON.parse(localStorage.getItem("CDUSER") || "{}");
    const orderDetails = {
      locationId: restaurantId,
      customerId: isDineInOrder ? '' : UserAuthId,
      deviceId: "",
      staffId: "",
      fullName: cdUser?.userName || "",
      email: "",
      phone: cdUser?.mobileNumber || "",
      totalItems: normalizedOrderItems?.length.toString(),
      comment: orderNote,
      orderTypeId: restaurantOrderTypeId, // ID for PickUp / Delivery / PreOrder
      orderTotal: orderTotal,
      isScheduleOrder: isSchedularOrder,
      items: normalizedOrderItems,
      totals: orderApiTotals,
      etaDate: pickUpDate,
      etaTime: isASAP || !cart.pickUpDate || cart.pickUpDate.length == 0  ? getWindowedTimeString() : cart.pickUpTime,
      pickUpDate: pickUpDate,
      pickUpTime: isASAP || !cart.pickUpDate || cart.pickUpDate.length == 0  ? getWindowedTimeString()  : cart.pickUpTime,
      deliveryDate: deliveryDate,
      deliveryTime:isASAP || !cart.deliveryTime || cart.deliveryTime.length == 0 ? getWindowedTimeString()  : cart.deliveryTime,
      locationDetails: locationDetails,
      addressLine1: locationDetails.locationInfo.text,
      // addressLine2: locationDetails.locationInfo.addressLine2,
      // addressLine3: locationDetails.locationInfo.addressLine3,
      orderSource: "O",
      guestCount:isDineInOrder ? guestCount : 1,
      isReceiveTransMsg:1,
      
    } as Cart;

    if (isDineInOrder) {
      orderDetails.tableId = tableId;
    }

    if(isEventDate && restaurantDetails){
      orderDetails.eventSlug = eventSlug;
      orderDetails.slotTime = eventSlot;

      orderDetails.isEventOrder = isEventDate;
      orderDetails.startEventTime = to24HourFormat(eventSlot?.split('-')[0]?.trim(' '));
       orderDetails.eventDate = cart.pickUpDate;
      orderDetails.pickUpDate = moment(`${cart.pickUpDate} ${cart.pickUpTime}`, "YYYY-MM-DD HH:mm:ss").utc().format("YYYY-MM-DD");
      orderDetails.etaDate = moment(`${cart.pickUpDate} ${cart.pickUpTime}`, "YYYY-MM-DD HH:mm:ss").utc().format("YYYY-MM-DD");
      orderDetails.pickUpTime = moment(cart.pickUpTime, "HH:mm:ss").utc().format("HH:mm:ss");
      orderDetails.etaTime = moment(cart.pickUpTime, "HH:mm:ss")?.tz(restaurantDetails.timeZoneCd).utc().format("HH:mm:ss");
    }

    if (isDineInOrder && orderDetails && isContactlessDineinV2) {
      orderDetails.sortOrder = 1;
    } else {
      orderDetails.sortOrder = 0;
    }
      const allStorage = getAllLocalStorageData();
        const cookies = getAllCookies();
 
    orderDetails.locationId.length > 0 && 
    !placeOrderLoading && 
       dispatch(placeOrder(orderDetails as any,allStorage as any,cookies as any));
  };

   const getAllLocalStorageData = () => {
  const data: Record<string, string | null> = {};
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key) {
      data[key] = localStorage.getItem(key);
    }
  }
 
  return data;
};
const getAllCookies = () => {
  return document.cookie
    .split("; ")
    .reduce((acc: Record<string, string>, cookie) => {
      const [name, ...rest] = cookie.split("=");
      acc[name] = decodeURIComponent(rest.join("="));
      return acc;
    }, {});
};
  
  const restaurantDetail = useSelector(
    (state: any) => state.restaurant.currentRestaurantDetail
  );

  const sortOrder = useMemo(() => {
    if (restaurantDetail.dining == 3) {
      return 1;
    } else if (restaurantDetail.dining == 2) {
      return 0;
    } else {
      return null;
    }
  }, [restaurantDetail]);


  const isTipAlreadyApplied = useMemo(() => {
    let tip: CartTotal | null = orderDetail
      ? getTotalByCode(orderDetail.totals, "3.0")
      : null;
    return tip ? parseInt(tip.value) : 0;
  }, [orderDetail]);

  const mergedItems = useMemo(() => {
    return [
      ...getEditCartItemFromCartItem(orderItems, []),
    ] as EditOrderItem[];
  }, [orderItems, runningCartDetails, orderDetail]);

  const mergedTotals = useMemo(() => {
    return [
      ...mergeTotals( orderApiTotals, orderDetail?.totals || [] ),
    ];
  }, [ orderDetail, runningCartDetails,  orderApiTotals ]);

  const updateOrder = (type: UpdateOrderType, updatedTipTotals?: CartTotal) => {

    const getUpdatedTotal = ( type: UpdateOrderType, updatedTipTotals?: CartTotal, cart?: Cart  ) => {
      if (type == "TotalUpdate" && updatedTipTotals && cart) {
        if (isTipAlreadyApplied >= 0) {
          return parseInt(orderTotal) + parseInt(updatedTipTotals.value);
        } else {
          return parseInt(orderTotal) + parseInt(updatedTipTotals.value);
        }
      } else {
        return getTotalByCode(mergedTotals, "5")?.value || 0;
      }
    };

    const orderDetails = orderDetail
      ? ({
          orderId: orderDetail.orderId,
          orderNo: orderDetail.orderNo,
          orderDate: orderDetail.orderDate,
          orderTime: orderDetail.orderTime,
          locationId: orderDetail.locationId,
          customerId: orderDetail.customerId,
          deviceId: "",
          staffId: "",
          fullName: orderDetail.fullName,
          email: "",
          phone: orderDetail.phone,
          comment: orderNote,
          address: "",
          orderTypeId: orderDetail?.orderTypeId,
          totalItems: mergedItems.length.toString(),
          status: "25",
          deliveryStaffId: orderDetail?.deliveryStaffId,
          addressLine1: orderDetail?.addressLine1,
          // addressLine2: orderDetail?.addressLine2,
          // addressLine3: orderDetail?.addressLine3,
          etaTime: isASAP || !cart.pickUpDate || cart.pickUpDate.length == 0 ? getWindowedTimeString(): cart.pickUpTime,
          etaDate: pickUpDate ? pickUpDate : orderDetail?.etaDate  ? getDateString(orderDetail.etaDate)  : null,
          pickUpTime:isASAP || !cart.pickUpDate || cart.pickUpDate.length == 0 ? getWindowedTimeString() : cart.pickUpTime,
          pickUpDate: pickUpDate ? pickUpDate : orderDetail?.pickUpDate ? getDateString(orderDetail.pickUpDate) : null,
          deliveryTime: isASAP || !cart.deliveryTime || cart.deliveryTime.length == 0 ? getWindowedTimeString()  : cart.deliveryTime,
          deliveryDate: deliveryDate ? deliveryDate  : orderDetail?.deliveryDate ? getDateString(orderDetail.deliveryDate) : null,

          items: mergedItems,
          totals: mergedTotals,
          orderTotal: getUpdatedTotal( type, updatedTipTotals, orderDetail as unknown as Cart  ),

          removedItemId: [],
          removedOptionId: [],

          locationName: null,
          locationMedia: null,
          orderTypeGroup: null,
          addressId: null,
          tableId: tableId,
          sortOrder: sortOrder,
          orderSource: "O",
          isReceiveTransMsg:1,
          isScheduleOrder:!isASAP
        } as EditOrderRequestCart)
      : null;

    if (type == "TotalUpdate" && orderDetails) { orderDetails.items = [];  }
    orderDetails && dispatch( updateOrderDetail({ cart: orderDetails, refundAmount: null,  }) );
  };

  return [
    makeOrder,
    updateOrder,
    getAmountInDecimal(isContactlessDineInOrder ? getTotalByCode(currentOrderDetail?.totals || [], "5")?.value || 0 : orderTotal),
    getAmountInDecimal(isContactlessDineInOrder ? getTotalByCode(currentOrderDetail?.totals || [], "1")?.value || 0 : orderItemSubTotals),
    orderApiTotals,
    getAmountInDecimal(isContactlessDineInOrder ? getTotalByCode(currentOrderDetail?.totals || [], "3")?.value || 0 : tipAmount),
    getAmountInDecimal(isContactlessDineInOrder ? getTotalByCode(currentOrderDetail?.totals || [], "6")?.value || 0 : discountAmount),
    getAmountInDecimal(DeliveryFee)
  ];
};
